import { render, staticRenderFns } from "./VMenuList.vue?vue&type=template&id=07075799&scoped=true&"
import script from "./VMenuList.vue?vue&type=script&lang=js&"
export * from "./VMenuList.vue?vue&type=script&lang=js&"
import style0 from "./VMenuList.vue?vue&type=style&index=0&id=07075799&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07075799",
  null
  
)

export default component.exports